<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <span>老人姓名 </span><el-input placeholder="输入老人姓名" v-model="searchKeyword" style="width: 220px"></el-input>
      <span> 原床位号 </span><el-input placeholder="输入原床位号" v-model="searchKeyword" style="width: 220px"></el-input>
      <span> 现床位号 </span><el-input placeholder="输入原床位号" v-model="searchKeyword" style="width: 220px"></el-input>
      <el-button type="primary" @click="getSearchData()">查询</el-button>
    </div>
    <div style="max-height: calc(100% - 120px);overflow-y: auto;margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="编号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="老人姓名"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="原床位号"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="现床位号"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="变更原因"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="操作时间"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="primary">变更推送</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'changeRecords',
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [{id: 1, name: 11}],
      searchKeyword: ''
    }
  },
  created () {
  },
  methods: {
    getSearchData () {},
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/changeRecords.vue